// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userAdd{width:530px;height:100%}.userAdd .el-form .el-form-item .el-form-item__content .el-input .el-input__inner{width:350px}.userAdd h1{margin-left:100px;height:40px}", ""]);
// Exports
module.exports = exports;
